/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["#shop-wrapper[_ngcontent-%COMP%]{background-color:#fafafa}#shop-wrapper.intro-background[_ngcontent-%COMP%]{background-color:#fff}@media (max-width:992px){#breadcrumb-header[_ngcontent-%COMP%]{display:none}}"];
export { styles as styles };
